import { prop } from 'ramda'

export const title = prop('title')
export const subtitle = prop('subtitle')
export const summary = prop('summary')
export const link = prop('link')
export const poster = prop('poster')
